import HACKATHON from "assets/avalancheBarcelona.png";
import AVALANCHEDAY from "assets/avalancheDay.png";

export const Sponsorships = [
  {
    image: HACKATHON,
    title: "Avalanche - Barcelona",
    price: 100,
  },
  {
    image: AVALANCHEDAY,
    title: "Avalanche Day Etkinligi",
    price: 30,
  },
];
